import React, { forwardRef, useEffect, useState } from 'react';

import { Control } from '@vlabs/uikit';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useCardPageFiltersTranslation } from '../i18n';
import { useCardPageFilters } from '../useCardPageFilters';

function UserDataFilterPopover(
  { ...props }: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useCardPageFiltersTranslation();

  const [localValue, setLocalValue] = useState<string>('');
  const { filters, updateFilters, updateFiltersDebounced } = useCardPageFilters();

  useEffect(() => {
    setLocalValue(filters.user_data ?? '');
  }, [filters]);

  const onChangeHandler = (user_data: string) => {
    setLocalValue(user_data);
    updateFiltersDebounced({ user_data });
  };

  const reset = () => updateFilters({ user_data: undefined });

  return (
    <PopoverWithButton
      {...props}
      onClickReset={reset}
      ref={ref}
      title={<div className="Body-2">{t('user_data_title')}</div>}
    >
      <Control.Input
        isClearable
        onChangeValue={onChangeHandler}
        onClear={reset}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

const UserDataFilterPopoverWithRef = forwardRef(UserDataFilterPopover);
export { UserDataFilterPopoverWithRef as UserDataFilterPopover };
